import _ from 'lodash';
import {
  HOME_POST_COUNT,
  ONLY_NUMBER_REGEX,
  PRESC_BLOG_COUNT
} from '../../constants/defaults';
import bffcli from './bffcli';
const { API } = require('./../../config/' + process.env.REACT_APP_ENV);

const errorHandler = err => {
  // TODO: Replace when functionality to metigate available.
  console.log(err);
};

// TODO unused - to remove
// const fetchStructuredData = async (drugQuery = "") => {
//   console.log("I'm here -- fetching structured data!")
//   try {
//     const drugStructureData = await goAxios.get(
//       `druginformation/${API.DRUG_STRUCTURE_VERSION}/GetDrugStructure?seoName=${drugQuery}&quantityLimit=6`
//     );
//     if (_.isEmpty(drugStructureData.data.defaultKey)) {
//       window.location.assign("/prescription-discount-card");
//     }
//     return drugStructureData;
//   } catch (err) {
//     errorHandler(err);
//     window.location.assign("/prescription-discount-card");
//   }
// };

// TODO unused - to remove
// const getGenericBrandIndex = (drugStructureData = {}) => {
//   let genericBrandId = 0;
//   if (!_.isEmpty(drugStructureData)) {
//     _.forEach(drugStructureData.drugs, (brand, index) => {
//       if (brand.forms[0].dosages[0].quantities[0].drug.isGeneric) {
//         genericBrandId = index;
//         return false;
//       }
//     });
//   }
//
//   return genericBrandId;
// };

export const fetchTieredPricing = async (
  quantity = '',
  zipCode = '',
  ndc = '',
  displayQuantity,
  isCustomQuantity
) => {
  try {
    const utmzCookies = _.getCookie('_utmz_custom').split('|');
    let prospectId = _.getCookie('prospect-id');
    let query = `?quantity=${quantity}`;
    if (ONLY_NUMBER_REGEX.test(zipCode)) {
      query += `&zipCode=${zipCode}`;
    } else if (
      !isNaN(zipCode?.coordinate?.latitude) &&
      !isNaN(zipCode?.coordinate?.longitude)
    ) {
      query += `&latitude=${parseFloat(
        zipCode?.coordinate?.latitude
      )}&longitude=${parseFloat(zipCode?.coordinate?.longitude)}`;
    }
    if (prospectId) query += `&prospectId=${prospectId}`;
    if (displayQuantity) query += `&displayQuantity=${displayQuantity}`;
    query += `&isCustomQuantity=${isCustomQuantity}`;
    const source = utmzCookies[2].split('=')[1];
    let url = `/prescription/pricing/${ndc}`;
    if (source === 'tvcampaign') {
      query += `&tenantId=${API.TV_TENANT_ID}`;
    }

    const tieredPricingData = await bffcli.get(url + query, {
      withCredentials: true
    });
    if (tieredPricingData) {
      return tieredPricingData.data && tieredPricingData.data;
    }
  } catch (err) {
    console.log(err);
    errorHandler(err);
    return err;
  }
};

// TODO unused - to remove
// export const fetchDrugInformation = async (ndc = "") => {
//   let version = API.ALLOW_DRUG_INFO_V2 ? "v2" : "v1";
//   try {
//     const drugInformationData = await axios.post(
//       API.GO_SERVER + `/druginformation/${version}/GetDrugInformation`,
//       ndc,
//       { withCredentials: true }
//     );
//     if (drugInformationData) {
//       return drugInformationData.data;
//     }
//   } catch (err) {
//     errorHandler(err);
//     return err;
//   }
// };

// TODO unused - to remove
// export const fetchIpLocation = async (ZipCode = "") => {
//   try {
//     const ipLocationData = await mainAxios.post(
//       "/services/v1_0/Public/MemberService.svc/GetIPLocation",
//       { ZipCode }
//     );
//
//     return ipLocationData.data;
//   } catch (err) {
//     return err;
//   }
// };

// TODO unused - to remove
// export const getDrugData = async (drugQuery = "") => {
//   let replaceableVariables = {};
//   const drugStructure = await fetchStructuredData(drugQuery);
//   if (!_.isEmpty(drugStructure.data)) {
//     const genericBrandIndex = getGenericBrandIndex(drugStructure.data);
//
//     const { defaultKey } = drugStructure.data;
//     if (defaultKey) {
//       replaceableVariables = {
//         priceUsualAndCustomary: defaultKey.priceUsualAndCustomary,
//         qty: defaultKey.quantity,
//         dosage: defaultKey.dosage,
//         form: defaultKey.form
//       };
//     }
//     try {
//       const formId = _.findFormIndex(
//         drugStructure.data.drugs,
//         genericBrandIndex,
//         defaultKey.form
//       );
//       const dosageId = _.findDosageIndex(
//         drugStructure.data.drugs,
//         genericBrandIndex,
//         formId,
//         defaultKey.dosage
//       );
//
//       const quantityId = _.findQuantityIndex(
//         drugStructure.data.drugs,
//         genericBrandIndex,
//         formId,
//         dosageId,
//         defaultKey.quantity
//       );
//
//       const {
//         drug,
//         brandTypes,
//         formTypes,
//         dosageData,
//         doNotMarket
//       } = _.parseDrugStructureData(
//         drugStructure.data.drugs,
//         genericBrandIndex,
//         formId,
//         dosageId,
//         quantityId
//       );
//
//       window.linkTruePill = API.ENABLE_TRUEPILL ? defaultKey.truePillLink : "";
//       return {
//         dosageData,
//         quantity: drug.quantity,
//         dosage: drug.Dosage,
//         brandTypes,
//         formTypes,
//         drugStructure: drugStructure.data.drugs,
//         defaultStructure: drug,
//         brandId: genericBrandIndex,
//         doNotMarket,
//         dosageId,
//         selectedQuantity: drug.displayQuantity,
//         replaceableVariables,
//         linkTruePill: defaultKey.truePillLink,
//         subTitleGeneric: defaultKey.subTitleGeneric,
//         subTitle: defaultKey.subTitle
//       };
//     } catch (err) {
//       console.log(err);
//     }
//   }
// };

export const fetchRelatedArticles = async (
  drugName = '',
  count = PRESC_BLOG_COUNT
) => {
  try {
    const blogData = await bffcli.get(
      `/cms/get-blogs-by-seo-name?slug=${drugName}&count=${count}`
    );
    if (blogData) {
      return blogData.data;
    }
  } catch (err) {
    errorHandler(err);
    return err;
  }
};

export async function fetchDrugClassRelatedBlogs(slug, count) {
  try {
    return (
      await bffcli.get(`/cms/get-blogs-by-seo-name?slug=${slug}&count=${count}`)
    ).data;
  } catch (err) {
    console.log(err);
  }
  return null;
}

export const fetchTopPosts = async (isFromLemonaid, postTags) => {
  try {
    let url = isFromLemonaid
      ? `/cms/get-blogs-by-tag?tag=LemonaidLP&count=3`
      : `/cms/get-blogs-by-tag?tag=seasonal&count=${HOME_POST_COUNT}`;
    url =
      postTags === 'medicare'
        ? '/cms/get-blogs-by-tag?tag=featured-medicare&count=4'
        : url;
    const blogData = await bffcli.get(url);
    if (blogData) {
      return blogData.data;
    }
  } catch (err) {
    errorHandler(err);
    return err;
  }
};

export const fetchDrugStructureSeoName = async (seoName, locale) => {
  try {
    const drugStructureData = await bffcli.get(
      `/drug-structure&seoName=${seoName}&locale=${locale}`
    );
    if (drugStructureData) {
      return drugStructureData.data.drugs;
    }
  } catch (err) {
    errorHandler(err);
    return err;
  }
};

// TODO remove - unused
// export const fetchPriceHistory = async (ndc, qty) => {
//   try {
//     const priceHistory = await goAxios.post(
//       `/druginformation/v2/gethistoricprices`,
//       { ndc, qty }
//     );
//     if (priceHistory) {
//       return priceHistory.data;
//     }
//   } catch (err) {
//     errorHandler(err);
//     return err;
//   }
// };

export const sendPharmacyEmail = async bodyFormData => {
  console.log('789 send pharmacy email');
  try {
    const sendEmailResponse = await bffcli.post(
      '/customer-information/send-pharmacy-email',
      bodyFormData
    );
    if (sendEmailResponse) {
      return sendEmailResponse;
    }
  } catch (err) {
    errorHandler(err);
    return err;
  }
};

// TODO unused - to remove
// export const getDrugContent = async seoName => {
//   try {
//     const drugContentResponse = await axios.get(
//       `/api/prescription/${seoName}`,
//       { withCredentials: true }
//     );
//     return drugContentResponse.data;
//   } catch (err) {
//     errorHandler(err);
//   }
// };

export const getDrugDetails = async seoName => {
  try {
    const getDrugDetailsRes = await bffcli.get(`/drug-detail/${seoName}`, {
      withCredentials: true
    });
    return getDrugDetailsRes.data;
  } catch (err) {
    errorHandler(err);
  }
};

export const signUpPriceAlert = async (
  email = '',
  drugNdc = '',
  quantity = '',
  zip = '',
  isCustomQuantity = false,
  isLoggedIn
) => {
  try {
    let utmParams = _.getUTMParams();
    const apiData = await bffcli.post(
      '/member-notification/create-price-alert',
      {
        email: email,
        ndc: drugNdc,
        quantity: isCustomQuantity ? parseInt(quantity) : quantity,
        zip: zip,
        alertType: 1,
        tenantId: 0,
        prospectId: !isLoggedIn ? _.getCookie('prospect-id') : null,
        isCustomQuantity: isCustomQuantity,
        contactTracking: {
          isLoyaltyMember: isLoggedIn,
          timeOffset: _.getCookie('timezone-offset'),
          ...utmParams
        }
      }
    );
    if (apiData) {
      return apiData;
    }
  } catch (err) {
    errorHandler(err);
    return err.response;
  }
};

export async function fetchUserSubscriptionData(id, preview, emailId) {
  let url = 'member-notification/getSubscriptionList';
  url += preview ? `?preview=${preview}` : `?preview=false`;
  if (emailId) url += `&emailId=${encodeURIComponent(emailId)}`;
  if (id) url += `&userExternalId=${id}`;
  try {
    return (await bffcli.get(url))?.data;
  } catch (err) {
    console.warn(err);
    return err?.response?.data;
  }
}

export const updateSubscriptions = async (
  subscriptionGroupID,
  subscribe,
  userExternalId,
  email
) => {
  let bodyData = {
    subscriptionGroupId: subscriptionGroupID,
    subscribe: subscribe
  };
  if (userExternalId) bodyData.userExternalId = userExternalId;
  if (email) bodyData.emailId = email;
  try {
    const apiData = await bffcli.put(
      '/member-notification/updateSubscriptions',
      bodyData
    );
    if (apiData) {
      return apiData;
    }
  } catch (err) {
    errorHandler(err);
    return err.response;
  }
};
